module.exports = __webpack_public_path__ + "img/gkzy-colour.dec782f0.png";